export default {
  name: "CustomTooltip",
  props: {
    text: String // 传入的 Tooltip 内容
  },
  data() {
    return {
      showTooltip: false,
      // 是否显示 Tooltip
      position: "top",
      // 默认位置
      timer: null
    };
  },
  methods: {
    updateTooltipPosition() {
      this.$nextTick(() => {
        const tooltip = this.$refs.tooltip;
        const target = this.$refs.target;
        if (!tooltip || !target) return;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        let textWidth = this.$refs.hiddenText.offsetWidth + 16; // 加上 padding
        const tooltipWidth = Math.min(textWidth, viewportWidth / 2);
        this.$refs.tooltip.style['width'] = tooltipWidth + 'px';
        const tooltipRect = tooltip.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        // console.log(123123, tooltipRect, targetRect, tooltipWidth, "viewportWidth", viewportWidth, targetRect.x - tooltipRect.x < tooltipWidth/2)
        // 自动调整 Tooltip 位置
        // if (targetRect.top - tooltipRect.height < 0) {
        //   this.position = "bottom";
        // } else if (targetRect.bottom + tooltipRect.height > viewportHeight) {
        //   this.position = "top";
        // }

        this.$refs.tooltip.style['left'] = Math.min(Math.max(targetRect.left - (tooltipRect.width - targetRect.width) / 2, 0), viewportWidth - tooltipWidth) + 'px';
        this.$refs.tooltip.style['top'] = targetRect.top - tooltipRect.height + 'px';
        // if (targetRect.left - tooltipWidth < 0) {
        //   this.position = "right";
        // } else if (targetRect.right + tooltipRect.width > viewportWidth) {
        //   this.position = "left";
        // }
      });
    },
    show() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.showTooltip = true;
        this.updateTooltipPosition();
      }, 400);
    },
    hide() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.showTooltip = false;
      }, 400);
    }
  }
};